import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { deleteUser } from '../config/Actions'
export default function UsersList() {
var users = useSelector(state=>state.users)
var dispatch = useDispatch()
function deleteTheUser(user){
    confirm('vous etes sure ?')
    dispatch(deleteUser(user))
}
  return (
    <>
    <h1>List of users</h1>
    <Link to='/add' className='btn btn-primary'>Add user</Link>
    <table className='table table-dark'>
        <thead>
            <tr>
            <th>#</th> 
            <th>Frist Name</th> 
            <th>Last Name</th> 
            <th>Age</th> 
            <th colSpan={3}>Actions</th> 
            </tr>
        </thead>
        <tbody>
            { users.map((user,i)=><tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.age}</td>
                <td><Link to={`/show/${user.id}`} className='btn btn-info'>Show</Link></td>
                <td><Link to={`/edit/${user.id}`} className='btn btn-success'>Edit</Link></td>
                <td><button onClick={()=>deleteTheUser(user)} className='btn btn-danger'>Delete</button></td> 
                </tr>)}
        </tbody>
    </table>
    </>
  )
}
